import React from "react";
import { Parallax } from "react-parallax";
import SubscribeForm from "./SubscribeForm";
import { mailChimpUrl } from "../config/commonConfig";
import MailchimpSubscribe from "react-mailchimp-subscribe";

function Subscribe() {
  return (
    ""
  );
}

export default Subscribe;
